import config from "@/config";
import http from "@/utils/request";

export default {
	materialLibrary: {
		category: {
			list: {
				url: `${config.API_URL}/admin/college_material_library_category/list`,
				name: "获取素材分类列表",
				post: async function (data = {}) {
					return await http.post(this.url, data);
				},
			},
			detail: {
				url: `${config.API_URL}/admin/material_category/detail`,
				name: "获取素材分类详情",
				post: async function (data = {}) {
					return await http.post(this.url, data);
				},
			},
			create: {
				url: `${config.API_URL}/admin/college_material_library_category/create`,
				name: "创建素材分类",
				post: async function (data = {}) {
					return await http.post(this.url, data);
				},
			},
			update: {
				url: `${config.API_URL}/admin/college_material_library_category/update`,
				name: "更新素材分类",
				post: async function (data = {}) {
					return await http.post(this.url, data);
				},
			},
			delete: {
				url: `${config.API_URL}/admin/college_material_library_category/delete`,
				name: "删除素材分类",
				post: async function (data = {}) {
					return await http.post(this.url, data);
				},
			},
			updateStatus: {
				url: `${config.API_URL}/admin/college_material_library_category/updateStatus`,
				name: "更新素材分类状态",
				post: async function (data = {}) {
					return await http.post(this.url, data);
				},
			},
		},
		dailySentence: {
			list: {
				url: `${config.API_URL}/admin/daily_sentence/list`,
				name: "获取每日一句列表",
				post: async function (data = {}) {
					return await http.post(this.url, data);
				},
			},
			detail: {
				url: `${config.API_URL}/admin/daily_sentence/detail`,
				name: "获取每日一句详情",
				post: async function (data = {}) {
					return await http.post(this.url, data);
				},
			},
			create: {
				url: `${config.API_URL}/admin/daily_sentence/create`,
				name: "创建每日一句",
				post: async function (data = {}) {
					return await http.post(this.url, data);
				},
			},
			update: {
				url: `${config.API_URL}/admin/daily_sentence/update`,
				name: "更新每日一句",
				post: async function (data = {}) {
					return await http.post(this.url, data);
				},
			},
			delete: {
				url: `${config.API_URL}/admin/daily_sentence/delete`,
				name: "删除每日一句",
				post: async function (data = {}) {
					return await http.post(this.url, data);
				},
			},
		},
		material: {
			list: {
				url: `${config.API_URL}/admin/college_material_library/list`,
				name: "获取素材列表",
				post: async function (data = {}) {
					return await http.post(this.url, data);
				},
			},
			detail: {
				url: `${config.API_URL}/admin/college_material_library/detail`,
				name: "获取素材详情",
				post: async function (data = {}) {
					return await http.post(this.url, data);
				},
			},
			create: {
				url: `${config.API_URL}/admin/college_material_library/create`,
				name: "创建素材",
				post: async function (data = {}) {
					return await http.post(this.url, data);
				},
			},
			update: {
				url: `${config.API_URL}/admin/college_material_library/update`,
				name: "更新素材",
				post: async function (data = {}) {
					return await http.post(this.url, data);
				},
			},
			delete: {
				url: `${config.API_URL}/admin/college_material_library/delete`,
				name: "删除素材",
				post: async function (data = {}) {
					return await http.post(this.url, data);
				},
			},
			updateStatus: {
				url: `${config.API_URL}/admin/college_material_library/updateStatus`,
				name: "更新素材状态",
				post: async function (data = {}) {
					return await http.post(this.url, data);
				},
			},
		},
	},
};
